import {LocalSecurityService} from '../../services/shared/local-security.service';
import {Router, RouterModule} from '@angular/router';
import {HasAppViewPermissionGuard} from '../../guards/has-app-view-permission.guard';
import { Component, OnInit, ViewChild, inject, AfterViewInit } from '@angular/core';
import { AppContextService, EcaSecurityService } from '@drc-eca/eca-components-lib';
import { MatTabChangeEvent, MatTabsModule, MatTabGroup } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-update',
    standalone: true,
    templateUrl: './update.component.html',
    styleUrls: ['./update.component.scss'],
    imports: [RouterModule, MatTabsModule, MatButtonModule]
})
export class UpdateComponent implements OnInit, AfterViewInit {
  private appContextSvc = inject(AppContextService);
  private hasAppViewPermissionGuard = inject(HasAppViewPermissionGuard);
  private router = inject(Router);
  private ecaSecurityService = inject(EcaSecurityService);
  private locaSecuritySvc = inject(LocalSecurityService);

  @ViewChild('navTabGroup')
  tabsComponent: MatTabGroup;
  selectedIndex = 0;
  tabs: any[];
  hasUpdatePermission: boolean = false;

  constructor() { }

  ngOnInit() {    
    this.appContextSvc.getSelectedProductCode().subscribe(() => {

      this.tabs = [
      {link:'services', label:'Services'},
      {link:'client', label:'Client'},
      {link:'issues', label:'Issues'},
      {link:'status-list', label:'Status Type'},
      {link:'maintenance', label:'Set Password'},
      {link:'viewpublicsite', label:'View Public Site'}];
    });

    const regex = /((?<=\/)[a-z]*)/g
    const matches = this.router.url.match(regex);
    let lastUrlSegment;
    if (matches.length > 0) {
      lastUrlSegment = matches.pop();
    }
    else {
      throw new Error("An error has occured while processing URL");
    }
    
    for (let index = 0; index < this.tabs.length; index++) {
      if (this.tabs[index].link === lastUrlSegment) {
        this.selectedIndex = index;
        break;
      }
    }
    this.hasAppViewPermissionGuard.userHasPermission().subscribe( hasPermission =>{
      this.hasUpdatePermission = hasPermission;

      setInterval(() => {
        const localSecurityOn = sessionStorage.getItem('localSecurityOn');        
        if(localSecurityOn || localSecurityOn == 'true'){   
          const token = sessionStorage.getItem('ngStorage-ecatoken').replace('"','').replace('"','');
          this.locaSecuritySvc.refreshToken(token).subscribe(
            (data: any)=>{
              sessionStorage.setItem('ngStorage-ecatoken', data.token);
            }, error=>{
              console.log(error);
            }
          );
        }else{
          this.ecaSecurityService.startTokenRefresh();
        }        
      }, 1000 * 60 * 10);
    });

  }  
  ngAfterViewInit(): void {
    this.tabsComponent.selectedIndex = this.selectedIndex;
  }

  onTabChanged(event: MatTabChangeEvent) {
    this.router.navigate([`/status/update/${this.tabs[event.index].link}`]).catch(console.log);

  }

  logOut(){
    sessionStorage.clear();
    this.router.navigateByUrl('/status/login');
  }

}
